module.exports = __webpack_public_path__ + "img/card_title2.afbf24f3.png";